import { makeStyles, tokens } from '@fluentui/react-components';

export const useConfigurationTabStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
  },
  accordion: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  accordionItem: {
    backgroundColor: tokens.colorNeutralBackground1,
    boxShadow: tokens.shadow4,
    borderRadius: tokens.borderRadiusXLarge,
    overflow: 'hidden',
  },
  accordionHeader: {
    '& button': {
      paddingBlock: tokens.spacingVerticalM,
      paddingInline: tokens.spacingHorizontalL,
      fontSize: tokens.fontSizeBase400,
      fontWeight: tokens.fontWeightSemibold,
    },
  },
  accordionPanel: {
    paddingInline: tokens.spacingHorizontalL,
    paddingBlockEnd: tokens.spacingVerticalL,
  },
});
